import { IBooking, IServiceItem } from 'shared-types/SharedTypes';
import { EditBookingTabs } from 'external-services/tab-selection-service/TabSelection.service';
import { IDiarySchedule } from 'shared-types/DiaryTypes';
import { IBookingChangeState } from 'external-services/booking-change-service/type';
import { IBookingStatus } from 'shared-types/index';
import { IServiceListItem } from 'booking-creator/components/RepeatBooking/types';

export interface ISetActiveBookingOnDateChange {
  newBooking: Partial<IBooking>;
  selectedService: IServiceItem; // @todo: change to 'activeService' name
  activeServiceViewList: IServiceListItem[];
  activeSchedule: IDiarySchedule;
}

export interface IDisplayState {
  mode: BookingMode;
  activeBooking: Partial<IBooking>; // @todo: move activeBooking to packages/components/booking-creator/src/app/reducers/activeBookings
  backupActiveBooking: Partial<IBooking>; // @todo: move activeBooking to packages/components/booking-creator/src/app/reducers/activeBookings
  activeBookingChanges: IBookingChangeState;
  slideOut: boolean;
  heading: string;
  tabVis: Map<string, EditBookingTabs>; // EditBookingTabs is from TabSelectionService, but use bellow one temporarily
  finalConfirmation: boolean;
  isLoading: boolean;
  originalBooking: Partial<IBooking>;
  durationManuallyEdited: boolean;
  hasCustomBookingDuration: boolean;
  selectedService: IServiceItem; // @todo: change to 'activeService' name
  activeServiceViewList: IServiceListItem[];
  activeSchedule: IDiarySchedule; // schedule for the date of the booking
  isBookingLoaded: boolean;
  isDateToday: boolean;
  isManualCopyOriginalBooking?: boolean;
  isManualPax?: boolean;
  bookingIdForEdit?: string;
}

export enum BookingMode {
  idle = 'idle',
  viewBooking = 'viewBooking',
  newBooking = 'newBooking',
  editBooking = 'editBooking',
}
